import { useState } from "react";
import {
    XIcon,
    ArrowLeftIcon,
    ClipboardList,
    MessageCircle,
} from "lucide-react";
import DialogViewLimit from "./dialog/dialog-view-limit";
import { useNavigate } from "react-router-dom";

interface AssessmentCreatorProps {
    onClose: () => void;
}

export function AssessmentCreator({ onClose }: AssessmentCreatorProps) {
    const navigate = useNavigate();
    const [isOpenModalViewLimit, setOpenModalViewLimit] = useState<boolean>(false);
    const [assessmentType, setAssessmentType] = useState<
        "survey" | "ai-interview" | null
    >(null);
    const [showAIInterviewCreator, setShowAIInterviewCreator] = useState(false);

    const handleBackFromAIInterview = () => {
        setShowAIInterviewCreator(false);
        setAssessmentType(null);
    };

    const handleBackFromSurvey = () => {
        setAssessmentType(null);
    };

    return (
        <>
            <div
                className="bg-white rounded-lg border shadow-sm p-6 mt-4"
            >
                <div
                    className="flex items-center justify-between mb-4"
                >
                    <div>
                        {(assessmentType || showAIInterviewCreator) && (
                            <button
                                onClick={
                                    showAIInterviewCreator
                                        ? handleBackFromAIInterview
                                        : handleBackFromSurvey
                                }
                                className="flex items-center text-gray-600 hover:text-gray-900 mb-2"
                            >
                                <ArrowLeftIcon
                                    className="h-4 w-4 mr-1"
                                />
                                <span
                                    className="text-sm"
                                >
                                    Back
                                </span>
                            </button>
                        )}
                        <h2
                            className="text-xl font-semibold text-gray-900"
                        >
                            Create Custom Screening
                        </h2>
                        <p
                            className="text-gray-700 text-sm"
                        >
                            Design screenings to evaluate applicant skills and qualifications
                        </p>
                    </div>
                    <button
                        onClick={() => onClose()}
                        className="p-1 rounded-full hover:bg-gray-100"
                    >
                        <XIcon
                            className="h-5 w-5 text-gray-600"
                        />
                    </button>
                </div>

                <div
                    className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6"
                >
                    <div
                        className="border rounded-lg p-6 hover:border-blue-500 hover:shadow-md cursor-pointer transition-all"
                        onClick={() => navigate("/assess/create/form")}
                    >
                        <div
                            className="flex items-center mb-4"
                        >
                            <div
                                className="p-2 bg-purple-50 rounded-full mr-3"
                            >
                                <ClipboardList
                                    className="h-6 w-6 text-purple-600"
                                />
                            </div>
                            <h3
                                className="text-lg font-medium text-gray-900"
                            >
                                Form
                            </h3>
                        </div>
                        <p
                            className="text-gray-700"
                        >
                            Create custom form questionnaires with multiple choice, short answer or rating scale questions to assess candidate qualifications.
                        </p>
                        <button
                            className="mt-4 text-blue-600 font-medium text-sm"
                        >
                            Create Form →
                        </button>
                    </div>

                    <div
                        className="border rounded-lg p-6 hover:border-blue-500 hover:shadow-md cursor-pointer transition-all"
                        onClick={() => navigate("/assess/create/interview")}
                    >
                        <div
                            className="flex items-center mb-4"
                        >
                            <div
                                className="p-2 bg-blue-50 rounded-full mr-3"
                            >
                                <MessageCircle
                                    className="h-6 w-6 text-blue-600"
                                />
                            </div>
                            <h3
                                className="text-lg font-medium text-gray-900"
                            >
                                AI Interview
                            </h3>
                        </div>
                        <p
                            className="text-gray-700"
                        >
                            Set up automated AI interviews that simulate real conversations to evaluate communication skills and technical knowledge.
                        </p>
                        <button
                            className="mt-4 text-blue-600 font-medium text-sm"
                        >
                            Create AI Interview →
                        </button>
                    </div>
                </div>
            </div>
            <DialogViewLimit
                open={isOpenModalViewLimit}
                onClose={setOpenModalViewLimit}
                title="You're on ourteam Preview"
                description={(
                    <p className="text-gray-500">
                        Browse up to 30 talent profiles and explore how ourteam works.
                        <br /><br />
                        To post a job or unlock full access, just email us at <b>hello@ourteam.ai</b>— we’ll get you started.
                    </p>
                )}
            />
        </>
    );
}
